export default [{
	uid:'canada',
	name_en:'Canada',
	name_fr:'Canada',
},
{
	uid:'us',
	name_en:'United States',
	name_fr:'États-Unis',
},
{
	uid:'uk',
	name_en:'United Kingdom',
	name_fr:'Royaume-Uni',
},
{
	uid:'multi',
	name_en:'Multinational Forces',
	name_fr:'Forces Multinationales',
},
{
	uid:'un',
	name_en:'United Nations',
	name_fr:'Nations Unies',
}];